import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import { Edit, Delete, Image as ImageIcon, CloudDownload, MoreVert } from '@material-ui/icons';
import { toastError, getUTCDateString } from '../../utils/Functions';
import FileEditDialog from './FileEditDialog';
import { trackPromise } from 'react-promise-tracker';
import { useMediaQuery, useTheme, MenuItem } from '@material-ui/core';
import IconButtonMenu from '../../components/IconButtonMenu';
import { useConfirmation } from '../../hooks/useConfirmation';
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import Autosizer from 'react-virtualized-auto-sizer';
import { getFileAndDownload } from './FileAPI';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingTop: 0,
  },
  icon: {
    marginRight: '8px',
  },
}));

export default function FileList(props) {
  const classes = useStyles();
  const [editDialogOpenIndex, setEditDialogOpenIndex] = React.useState(-1);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });

  const confirm = useConfirmation();

  const handleClick = (value) => {
    if (props.setSelectedFile) props.setSelectedFile(value === props.selectedFileID ? '' : value);
    else if (props.showFile) props.showFile(value);
  };

  const handleFileChanges = (fileChanges) => {
    var file = props.files[editDialogOpenIndex];
    file = { ...file, ...fileChanges };
    if (props.updateFile) props.updateFile(file);
    setEditDialogOpenIndex(-1);
  };

  const handleFileDelete = (i) => {
    var file = props.files[i ?? editDialogOpenIndex];
    if (file && props.deleteFile) {
      confirm('Are you sure you want to delete this file?').then(() => {
        props.deleteFile(file);
      });
    }
    setEditDialogOpenIndex(-1);
  };

  const downloadFile = (file) => {
    if (file)
      trackPromise(getFileAndDownload(file.uniqueId, file.fileNickname + file.fileExtension)).catch((err) => {
        toastError(props.toast, err);
      });
  };

  return (
    <>
      <Autosizer>
        {({ height, width }) => (
          <FixedSizeList height={height} width={width} className={classes.root} itemSize={64} itemCount={props.files.length} itemData={props.files}>
            {(childProps: ListChildComponentProps) => {
              let style = childProps.style;
              let index = childProps.index;
              let data = childProps.data[index];
              return (
                <ListItem
                  key={data.id + '_' + index}
                  id={data.id + '_' + index}
                  dense
                  button
                  onClick={() => {
                    handleClick(data.id);
                  }}
                  // @ts-ignore
                  ContainerProps={{ style: style }}
                  ContainerComponent='div'
                >
                  {props.setSelectedFile ? (
                    <Checkbox
                      edge='start'
                      checked={props.selectedFileID === data.id ? true : false}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-labelledby': `checkbox-list-label-${data.id}` }}
                    />
                  ) : null}
                  <ListItemText
                    id={`checkbox-list-label-${data.id}`}
                    primary={data.fileNickname + data.fileExtension}
                    secondary={getUTCDateString(data.createdDate) + (data.linkedRecordType ? '-' + data.linkedRecordType : '')}
                    style={{ textOverflow: 'ellipsis' }}
                  />
                  <ListItemSecondaryAction style={{ right: 0 }}>
                    {!isMobile ? (
                      <>
                        <IconButton onClick={() => (props.deleteMode ? handleFileDelete(index) : setEditDialogOpenIndex(index))} style={{ marginRight: '0' }}>
                          {props.deleteMode ? <Delete /> : <Edit />}
                        </IconButton>
                        <IconButton onClick={() => (data.type === 'application/pdf' ? downloadFile?.(data) : props.showFile?.(data.id))} style={{ marginRight: '0' }}>
                          <ImageIcon />
                        </IconButton>
                        <IconButton onClick={() => downloadFile?.(data)}>
                          <CloudDownload />
                        </IconButton>
                      </>
                    ) : (
                      <IconButtonMenu Icon={MoreVert}>
                        <MenuItem onClick={() => (props.deleteMode ? handleFileDelete(index) : setEditDialogOpenIndex(index))}>
                          <Edit className={classes.icon} />
                          Edit
                        </MenuItem>
                        <MenuItem onClick={() => (data.type === 'application/pdf' ? downloadFile?.(data) : props.showFile?.(data.id))}>
                          <ImageIcon className={classes.icon} />
                          Preview
                        </MenuItem>
                        <MenuItem onClick={() => downloadFile?.(data)}>
                          <CloudDownload className={classes.icon} />
                          Download
                        </MenuItem>
                        <MenuItem onClick={() => handleFileDelete(index)}>
                          <Delete className={classes.icon} />
                          Delete
                        </MenuItem>
                      </IconButtonMenu>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
              );
            }}
          </FixedSizeList>
        )}
      </Autosizer>
      <FileEditDialog
        open={editDialogOpenIndex >= 0}
        close={() => setEditDialogOpenIndex(-1)}
        save={handleFileChanges}
        file={props.files[editDialogOpenIndex]}
        toast={props.toast}
      />
    </>
  );
}
